import React from "react";
import { CheckCircle2, Loader2, AlertCircle, X } from 'lucide-react';
import { UploadBatchProgress } from '@/hooks/useUploadProgress';
import { Progress } from '@/components/ui/progress';

interface UploadProgressToastProps {
  progress: UploadBatchProgress;
  onDismiss: () => void;
  onNavigateToUpload: () => void;
}

export function UploadProgressToast({ progress, onDismiss, onNavigateToUpload }: UploadProgressToastProps) {
  const label = progress.isInitializing
    ? 'Preparing upload...'
    : progress.isComplete
      ? progress.hasErrors
        ? `Done — ${progress.completedFiles}/${progress.totalFiles} uploaded • ${progress.failedFiles} failed`
        : `Upload complete (${progress.completedFiles}/${progress.totalFiles})`
      : `Uploading ${progress.completedFiles + progress.failedFiles}/${progress.totalFiles}...`;

  return (
    <div className="fixed bottom-4 right-4 z-50 w-80 rounded-lg border border-border bg-card shadow-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {progress.isComplete ? (
            progress.hasErrors ? (
              <AlertCircle className="h-4 w-4 text-destructive" />
            ) : (
              <CheckCircle2 className="h-4 w-4 text-success" />
            )
          ) : (
            <Loader2 className="h-4 w-4 text-primary animate-spin" />
          )}
          <span className="text-sm font-medium text-foreground">{label}</span>
        </div>

        <button onClick={onDismiss} className="text-muted-foreground hover:text-foreground transition-colors">
          <X className="h-4 w-4" />
        </button>
      </div>

      <Progress value={progress.progress} className="h-1.5 transition-all duration-500 ease-out" />

      <button
        onClick={onNavigateToUpload}
        className="text-xs text-primary hover:text-primary/80 transition-colors"
      >
        View details →
      </button>
    </div>
  );
}
